<template>
    <div v-if="loading" class="hiq-loader">
        <span class="show-for-sr" aria-live="polite">{{translations.loading}}</span>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
</template>
<script>
import Vue from 'vue'
export default Vue.extend({
    name: 'loader',
    computed: {
        loading() {
            return this.$store.state.loading;
        },
        translations() {
            return this.$store.state.translations;
        }
    }
})
</script>